import { Component, OnDestroy, OnInit } from '@angular/core';
import { WebRouletteService } from 'app/public/services/web-roulette.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';
import { BaseLids } from '../../base-lids';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';

@Component({
  selector: 'app-lids-mobile',
  templateUrl: './lids-mobile.component.html',
  styleUrls: ['./lids-mobile.component.scss']
})
export class LidsMobileComponent extends BaseLids implements OnInit, OnDestroy {
  displaySidebar: boolean = false;

  constructor(webRouletteService: WebRouletteService,managmentService:BusinessManagmentService,  localizationService: LocalizationService, commonService: CommonService) {
    super(webRouletteService,managmentService, localizationService, commonService)
  }
  ngOnDestroy(): void {
    if (!this.businessId)
      this.destroy();
  }
  ngOnInit(): void {
    this.init();
    this.loadLids()
  }

}


